import React from 'react';

/** Подпись сверху, поле на всю ширину — без горизонтального label+input */
export default function FormField({ label, hint, children, className = '' }) {
    return (
        <div className={`pos-field ${className}`.trim()}>
            {label && <span className="pos-field__label">{label}</span>}
            {children}
            {hint && <span className="pos-field__hint">{hint}</span>}
        </div>
    );
}

export function PosInput(props) {
    return <input className="pos-input" {...props} />;
}

export function PosSelect({ children, ...props }) {
    return <select className="pos-select" {...props}>{children}</select>;
}
